import React from 'react';
import { AlertCircleIcon, CheckCircleIcon, UploadIcon } from 'lucide-react';
interface DocumentUploadSelectorProps {
  clientId: string;
  documentiRichiesti: {
    fatture: boolean;
    contratto: boolean;
    solleciti: boolean;
    altro: boolean;
  };
  onDocumentUpload: (clientId: string, documentType: keyof typeof documentiRichiesti) => void;
}
export function DocumentUploadSelector({
  clientId,
  documentiRichiesti,
  onDocumentUpload
}: DocumentUploadSelectorProps) {
  // Calcola il numero di documenti mancanti
  const documentiMancanti = Object.values(documentiRichiesti).filter(v => !v).length;
  const documentiTotali = Object.values(documentiRichiesti).length;
  const documentiCaricati = documentiTotali - documentiMancanti;
  // Determina il colore del badge in base ai documenti mancanti
  const getBadgeColor = () => {
    if (documentiMancanti === 0) return 'bg-green-100 text-green-800';
    if (documentiMancanti <= documentiTotali / 2) return 'bg-yellow-100 text-yellow-800';
    return 'bg-red-100 text-red-800';
  };
  return <div data-id="element-742">
      <div className="flex items-center mb-2" data-id="element-743">
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getBadgeColor()}`} data-id="element-744">
          {documentiCaricati}/{documentiTotali} documenti
        </span>
        {documentiMancanti > 0 && <span className="ml-2 text-xs text-red-600" data-id="element-745">
            {documentiMancanti} mancanti
          </span>}
      </div>
      <div className="space-y-2" data-id="element-746">
        <div className="flex items-center" data-id="element-747">
          {documentiRichiesti.fatture ? <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-748" /> : <button onClick={() => onDocumentUpload(clientId, 'fatture')} className="inline-flex items-center text-xs text-blue-600 hover:text-blue-900" data-id="element-749">
              <UploadIcon className="h-3 w-3 mr-1" data-id="element-750" />
              Carica fatture
            </button>}
        </div>
        <div className="flex items-center" data-id="element-751">
          {documentiRichiesti.contratto ? <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-752" /> : <button onClick={() => onDocumentUpload(clientId, 'contratto')} className="inline-flex items-center text-xs text-blue-600 hover:text-blue-900" data-id="element-753">
              <UploadIcon className="h-3 w-3 mr-1" data-id="element-754" />
              Carica contratto
            </button>}
        </div>
        <div className="flex items-center" data-id="element-755">
          {documentiRichiesti.solleciti ? <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-756" /> : <button onClick={() => onDocumentUpload(clientId, 'solleciti')} className="inline-flex items-center text-xs text-blue-600 hover:text-blue-900" data-id="element-757">
              <UploadIcon className="h-3 w-3 mr-1" data-id="element-758" />
              Carica solleciti
            </button>}
        </div>
        <div className="flex items-center" data-id="element-759">
          {documentiRichiesti.altro ? <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-760" /> : <button onClick={() => onDocumentUpload(clientId, 'altro')} className="inline-flex items-center text-xs text-blue-600 hover:text-blue-900" data-id="element-761">
              <UploadIcon className="h-3 w-3 mr-1" data-id="element-762" />
              Altra documentazione
            </button>}
        </div>
      </div>
    </div>;
}